import { createSlice } from '@reduxjs/toolkit'

const initialState = localStorage.getItem('mode') == 'dark' ? 'dark' : 'light'

const modeSlice = createSlice({
    name: 'mode',
    initialState,
    reducers: {
        toggleMode: (state) => {
            const newMode = state === 'light' ? 'dark' : 'light'
            localStorage.setItem('mode', newMode)
            return newMode
        }
    }
})

export const { toggleMode } = modeSlice.actions
export default modeSlice.reducer